// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n4Kh","content":"styles_content__28QS9","tableWrap":"styles_tableWrap__10FLp"};